import React, {
  useState,
  useEffect
} from 'react'
import {
  Form,
  Slider
} from 'antd'

const SliderField = props => {

  const { value, onChange } = props

  const form = Form.useFormInstance()
  const [ formContext, setFormContext ] = useState()

  const maxvalue = parseInt(props.parent.attribs['data-maxvalue'])
  const step = parseInt(props.parent.attribs['data-step'])

  useEffect(() => {

    if(form) {
      
      setFormContext(form)
    }

  }, [form])

  return <>
    <Slider 
        max={ maxvalue }
        min={ 0 }
        step={ step }
        value={ value }
        onChange={ onChange }
        disabled={ formContext?.eventData?.instance.closed }
      /> 
      <div className="Value">
        { value }
      </div>
  </>
}

export const Punctuation = props => { 

  const required = props.parent.attribs['data-required'] == 'true'

  return <div className="wp-block-playmotivcloud-surveyanswer punctuation">
    <Form.Item
      name={props.parent.attribs['data-blockid']}
      rules={[{ required: required, message: "Este campo es obligatorio" }]}
    >
      <SliderField { ...props } />
    </Form.Item>
  </div>
}
